'use client'

import { useIsLoggedInQuery } from 'auth/hooks'
import * as React from 'react'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useRouter } from 'next/navigation'

export function AuthenticatedOnly({
  children,
  redirectToLogin,
  skeleton,
}: {
  children: React.ReactNode
  redirectToLogin?: boolean
  skeleton?: React.ReactNode
}) {
  const isLoggedInQuery = useIsLoggedInQuery()
  const loggedIn = isLoggedInQuery.data
  const loading = isLoggedInQuery.isPending
  const { push } = useRouter()

  React.useEffect(() => {
    if (!loggedIn && !loading && redirectToLogin) {
      return push(AppRoutes.LOGIN)
    }
  }, [loggedIn, redirectToLogin, push, loading])

  if (!loggedIn) {
    return skeleton ?? null
  }

  return children
}
